(function () {
  document.documentElement.classList.remove('no-js');

  // Built-in navigation stays on the current page when its section exists here.
  document.querySelectorAll('[data-local-section-link]').forEach(function (link) {
    var url = new URL(link.href, window.location.href);
    if (url.hash && document.getElementById(decodeURIComponent(url.hash.slice(1)))) link.setAttribute('href', url.hash);
  });

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (event) {
      if (!event.target.closest('a')) return;
      nav.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
    (btn.closest('header') || nav).addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (btn.getAttribute('aria-expanded') !== 'true') return;
      nav.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    });
  });

  // Country / currency selector submits on change
  document.querySelectorAll('[data-localization-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      if (sel.form.requestSubmit) sel.form.requestSubmit();
      else sel.form.submit();
    });
  });

  document.querySelectorAll('[data-reserve-partnership]').forEach(function (link) {
    link.addEventListener('click', function () {
      var section = link.closest('[data-reserve-section]') || link.closest('section');
      var select = section && section.querySelector('[data-reserve-field="configuration"]');
      if (!select) return;
      var option = Array.prototype.find.call(select.options, function (item) { return /partnership/i.test(item.textContent); });
      if (option) { select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); select.focus(); }
    });
  });

  // Keep trade enquiries distinct from an individual vehicle build.
  document.querySelectorAll('[data-reserve-section]').forEach(function (section) {
    var configuration = section.querySelector('[data-reserve-field="configuration"]');
    var car = section.querySelector('[data-reserve-car]');
    var design = section.querySelector('[data-reserve-field="form"]');
    if (!configuration || !car) return;
    var carRequired = car.required;
    var carPlaceholder = car.placeholder;
    var message = section.querySelector('textarea[name="contact[body]"]');
    var messagePlaceholder = message && message.placeholder;
    var designField = design && design.closest('.field');
    var copies = Array.prototype.map.call(section.querySelectorAll('[data-partnership-copy]'), function (element) {
      return { element: element, original: element.innerHTML };
    });
    function updateEnquiryMode() {
      var partnership = /partnership/i.test(configuration.value);
      car.required = partnership ? false : carRequired;
      car.placeholder = partnership ? 'Vehicle or project, if applicable' : carPlaceholder;
      if (message) message.placeholder = partnership ? 'Workshop, location and partnership interests' : messagePlaceholder;
      if (design) design.disabled = partnership;
      if (designField) designField.hidden = partnership;
      copies.forEach(function (item) {
        if (partnership) item.element.textContent = item.element.dataset.partnershipCopy;
        else item.element.innerHTML = item.original;
      });
    }
    configuration.addEventListener('change', updateEnquiryMode);
    updateEnquiryMode();
  });

  function handle(s) { var value = String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); return value === 'lattice' ? 'tessera' : value === 'twist' ? 'arc' : value; }

  function selectReserveValue(select, value) {
    if (!value) return;
    var option = Array.prototype.find.call(select.options, function (item) { return handle(item.value) === handle(value); });
    if (option) { select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  // The enquiry form shows and sends the full selection made on the product page.
  function setReserveSelection(text) {
    document.querySelectorAll('[data-reserve-selection-field]').forEach(function (field) {
      var form = field.closest('form');
      if (form && form.querySelector('[data-reserve-response]')) return;
      field.hidden = !text;
      var out = field.querySelector('[data-reserve-selection-text]');
      var input = field.querySelector('[data-reserve-selection]');
      if (out) out.textContent = text || '';
      if (input) input.value = text || '';
    });
  }

  // A separate contact page can receive the same choices as the product page.
  var enquiryParams = new URLSearchParams(window.location.search);
  if (enquiryParams.get('selection')) setReserveSelection(enquiryParams.get('selection'));
  document.querySelectorAll('[data-reserve-field]').forEach(function (select) {
    if (select.form && select.form.querySelector('[data-reserve-response]')) return;
    var value = select.dataset.reserveField === 'form' ? enquiryParams.get('form') : enquiryParams.get('configuration') || enquiryParams.get('config');
    selectReserveValue(select, value);
  });

  document.querySelectorAll('[data-component-link]').forEach(function (link) {
    link.addEventListener('click', function () {
      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      var configuration = link.dataset.configuration;
      if (url.hash) {
        var section = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        var select = section && section.querySelector('[data-reserve-field="configuration"]');
        if (select) selectReserveValue(select, configuration);
        return;
      }
      // Keep the selected form and market/preview parameters when changing assembly.
      var current = new URL(window.location.href);
      var product = document.querySelector('[data-product]');
      if (product) {
        var formOption = Array.prototype.find.call(product.querySelectorAll('[data-option-index]'), function (option) { return option.dataset.optionName === product.dataset.formOption; });
        var selected = formOption && formOption.querySelector('input:checked');
        if (selected) current.searchParams.set('form', selected.value);
      }
      current.searchParams.delete('variant');
      current.searchParams.delete('config');
      current.searchParams.set('configuration', configuration);
      current.hash = '';
      link.href = current.toString();
    });
  });

  // model-viewer is loaded as a module from the sections that need it; this creates one on demand.
  function makeViewer(src, alt) {
    var mv = document.createElement('model-viewer');
    mv.setAttribute('src', src);
    mv.setAttribute('alt', alt || '');
    mv.setAttribute('camera-controls', '');
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) mv.setAttribute('auto-rotate', '');
    mv.setAttribute('auto-rotate-delay', '600');
    mv.setAttribute('rotation-per-second', '18deg');
    mv.setAttribute('interaction-prompt', 'none');
    mv.setAttribute('shadow-intensity', '0.9');
    mv.setAttribute('shadow-softness', '0.8');
    mv.setAttribute('exposure', '1.05');
    mv.setAttribute('environment-image', 'neutral');
    mv.setAttribute('tone-mapping', 'commerce');
    mv.setAttribute('touch-action', 'pan-y');
    mv.setAttribute('camera-orbit', '-28deg 64deg 72%');
    mv.setAttribute('field-of-view', '24deg');
    return mv;
  }

  // Product page: options drive the price, the photo set, the 3D model and the "in the box" panel.
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = root.querySelector('[data-product-form]');
    var gallery = root.querySelector('[data-gallery]');
    if (!form || !gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    var modelBox = gallery.querySelector('[data-gallery-model]');
    var caption = gallery.querySelector('[data-gallery-caption]');
    var toggle = gallery.querySelector('[data-view-toggle]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var configName = root.dataset.configOption;
    var formName = root.dataset.formOption;
    var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var addonSets = Array.prototype.slice.call(form.querySelectorAll('[data-addon-group]'));
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var depositPercent = Number(root.dataset.depositPercent) || 0;
    var options = fieldsets.map(function (fs) {
      return {
        name: fs.dataset.optionName,
        values: Array.prototype.map.call(fs.querySelectorAll('input'), function (i) { return handle(i.value); }),
        labels: Array.prototype.map.call(fs.querySelectorAll('input'), function (i) { return i.value; })
      };
    });
    var variants = [];
    try { variants = JSON.parse(form.querySelector('[data-variants-json]').textContent); } catch (e) {}
    var models = {};
    try { models = JSON.parse(form.querySelector('[data-models-json]').textContent); } catch (e) {}
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-product-price]');
    var depositEl = root.querySelector('[data-product-deposit]');
    var buyBtn = form.querySelector('[data-buy-button]');
    var enquire = root.querySelector('[data-enquire-link]');
    var enquireHref = enquire ? enquire.getAttribute('href') : '';
    var labels = buyBtn ? { add: buyBtn.dataset.labelAdd, sold: buyBtn.dataset.labelSold } : {};
    var view = 'photo';
    var viewer = null;

    thumbs.forEach(function (t) {
      t._tags = (t.dataset.tags || '').split(/[·|,]/).map(handle).filter(Boolean);
      t.addEventListener('click', function () { showPhoto(t); });
    });

    function selection() {
      return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? handle(c.value) : null; });
    }
    function selectedLabel(name) {
      var i = options.findIndex(function (o) { return o.name === name; });
      if (i < 0) return '';
      var c = fieldsets[i].querySelector('input:checked');
      return c ? c.value : '';
    }
    function selectedHandle(name) { return handle(selectedLabel(name)); }

    function formatMoney(cents) {
      function group(n, decimals, sep, dec) {
        var parts = (n / 100).toFixed(decimals).split('.');
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (parts[1] ? dec + parts[1] : '');
      }
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        if (key === 'amount_no_decimals') return group(cents, 0, ',', '.');
        if (key === 'amount_with_comma_separator') return group(cents, 2, '.', ',');
        if (key === 'amount_no_decimals_with_comma_separator') return group(cents, 0, '.', ',');
        if (key === 'amount_with_apostrophe_separator') return group(cents, 2, "'", '.');
        return group(cents, 2, ',', '.');
      });
    }

    function variantFor(values) {
      return variants.find(function (x) { return x.options.every(function (o, i) { return o === values[i]; }); });
    }

    // Add-ons apply only to the configurations they are offered with; the rest are hidden and not charged.
    function selectedAddons() {
      var config = selectedHandle(configName);
      var list = [];
      addonSets.forEach(function (fs) {
        var choices = Array.prototype.slice.call(fs.querySelectorAll('input[data-addon-price]'));
        var offered = choices.some(function (i) { return !i.dataset.applies || i.dataset.applies.split(',').indexOf(config) > -1; });
        fs.hidden = !offered;
        var picked = fs.querySelector('input:checked');
        var property = fs.querySelector('[data-addon-property]');
        var active = offered && picked && !picked.hasAttribute('data-addon-none');
        if (property) { property.disabled = !active; property.value = active ? picked.value : ''; }
        if (active) list.push({ group: fs.querySelector('legend').textContent.trim(), label: picked.value, price: Number(picked.dataset.addonPrice) || 0, variant: picked.dataset.addonVariant });
      });
      return list;
    }

    // Each configuration shows its price, each material its surcharge, for the rest of the current choice.
    function updateHints() {
      var current = fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      fieldsets.forEach(function (fs, index) {
        var inputs = Array.prototype.slice.call(fs.querySelectorAll('input'));
        var prices = inputs.map(function (input) {
          var values = current.slice();
          values[index] = input.value;
          var v = variantFor(values);
          return v && !v.on_request && typeof v.price === 'number' ? v.price : null;
        });
        inputs.forEach(function (input, i) {
          var hint = input.nextElementSibling && input.nextElementSibling.querySelector('[data-price-hint]');
          if (!hint) return;
          if (prices[i] === null) { hint.textContent = ''; return; }
          if (fs.dataset.optionName === configName) hint.textContent = formatMoney(prices[i]);
          else hint.textContent = prices[0] !== null && prices[i] > prices[0] ? '+' + formatMoney(prices[i] - prices[0]) : '';
        });
      });
    }

    function selectionText(v, total) {
      var parts = fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : ''; });
      selectedAddons().forEach(function (a) { parts.push(a.label); });
      if (v && !v.on_request && typeof v.price === 'number') parts.push(formatMoney(total));
      return parts.filter(Boolean).join(' · ');
    }

    function matches(t, sel) {
      return options.every(function (opt, i) {
        if (opt.name === configName && sel[i] === opt.values[0]) return true;
        var mentioned = opt.values.filter(function (v) { return t._tags.indexOf(v) > -1; });
        if (!mentioned.length) return opt.name !== configName;
        return mentioned.indexOf(sel[i]) > -1;
      });
    }

    function visibleThumbs() {
      return thumbs.filter(function (t) { return !t.hidden; }).sort(function (a, b) { return (a._rank || 0) - (b._rank || 0); });
    }

    // Photos of the selected assembly alone lead; shared shots (e.g. cat-back with tips) follow.
    function rank(t, sel) {
      var i = options.findIndex(function (o) { return o.name === configName; });
      if (i < 0 || sel[i] === options[i].values[0]) return 0;
      return options[i].values.filter(function (v) { return t._tags.indexOf(v) > -1; }).length > 1 ? 1 : 0;
    }

    function setCaption(t) {
      if (!caption) return;
      var parts = [selectedLabel(formName), selectedLabel(configName)].filter(Boolean);
      if (view === 'model') { caption.textContent = parts.concat(['3D model, drag to rotate']).join(' · '); return; }
      var list = visibleThumbs();
      var n = list.indexOf(t) + 1;
      // The photo's own caption already names the assembly, so only the form goes in front of it.
      caption.textContent = [selectedLabel(formName), t ? t.dataset.alt : ''].filter(Boolean).join(' · ') + (list.length > 1 && n ? '  ·  ' + n + ' / ' + list.length : '');
    }

    // Fit the photo to the stage and extend its studio background into the bars with a gradient of its edge colours.
    var stage = gallery.querySelector('[data-gallery-stage]');
    function fit(t) {
      var r = parseFloat(t.dataset.ratio) || 0;
      var sr = stage.clientWidth / Math.max(stage.clientHeight, 1) || 1.7;
      var e = (t.dataset.edges || '').split(',');
      var wide = !r || r >= sr;
      stage.classList.toggle('is-letterbox', wide);
      stage.classList.toggle('is-pillarbox', !wide);
      if (e.length === 4 && r) {
        var bar = (wide ? (1 - sr / r) : (1 - r / sr)) * 50;
        var a = wide ? e[0] : e[2], b = wide ? e[1] : e[3];
        stage.style.setProperty('--stage-bg', 'linear-gradient(' + (wide ? 'to bottom' : 'to right') + ',' + a + ' 0%,' + a + ' ' + bar.toFixed(1) + '%,' + b + ' ' + (100 - bar).toFixed(1) + '%,' + b + ' 100%)');
      } else {
        stage.style.removeProperty('--stage-bg');
      }
    }
    window.addEventListener('resize', function () {
      var t = thumbs.find(function (x) { return x.getAttribute('aria-current') === 'true'; });
      if (t) fit(t);
    });

    function showPhoto(t) {
      if (!t) return;
      setView('photo');
      fit(t);
      main.src = t.dataset.src;
      main.srcset = t.dataset.srcset || '';
      main.alt = t.dataset.alt || '';
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      setCaption(t);
    }

    function filterPhotos() {
      var sel = selection();
      var any = false;
      thumbs.forEach(function (t) {
        t.hidden = !matches(t, sel);
        t._rank = rank(t, sel);
        t.style.order = t._rank;
        if (!t.hidden) any = true;
      });
      if (!any) thumbs.forEach(function (t) { t.hidden = false; });
      var current = thumbs.find(function (t) { return t.getAttribute('aria-current') === 'true' && !t.hidden; });
      if (view === 'model') { setCaption(null); return; }
      showPhoto(current && current === visibleThumbs()[0] ? current : visibleThumbs()[0]);
    }

    function currentModel() { return models[selectedHandle(formName)] || null; }

    function setView(v) {
      var m = currentModel();
      if (v === 'model' && !m) v = 'photo';
      view = v;
      if (toggle) toggle.querySelectorAll('[data-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === v ? 'true' : 'false'); });
      main.hidden = v === 'model';
      modelBox.hidden = v !== 'model';
      if (v === 'model') {
        if (!viewer) {
          viewer = makeViewer(m.src, m.alt);
          viewer.addEventListener('error', function () {
            var key = Object.keys(models).find(function (k) { return models[k].src === viewer.getAttribute('src'); });
            if (key) delete models[key];
            updateToggle();
            setView('photo');
            showPhoto(visibleThumbs()[0]);
          });
          modelBox.appendChild(viewer);
        } else if (viewer.getAttribute('src') !== m.src) {
          viewer.setAttribute('src', m.src);
          viewer.setAttribute('alt', m.alt);
        }
        setCaption(null);
      }
    }
    function updateToggle() {
      if (!toggle) return;
      toggle.hidden = !currentModel();
      if (toggle.hidden && view === 'model') setView('photo');
    }
    if (toggle) toggle.addEventListener('click', function (e) {
      var b = e.target.closest('[data-view]');
      if (!b) return;
      if (b.dataset.view === 'model') setView('model');
      else showPhoto(visibleThumbs().find(function (t) { return t.getAttribute('aria-current') === 'true'; }) || visibleThumbs()[0]);
    });

    function updatePanels(preserveResponse) {
      var f = selectedHandle(formName), c = selectedHandle(configName);
      root.querySelectorAll('[data-panel-form]').forEach(function (el) { el.hidden = el.dataset.panelForm !== f; });
      root.querySelectorAll('[data-panel-config]').forEach(function (el) { el.hidden = el.dataset.panelConfig !== c; });
      document.querySelectorAll('[data-reserve-field]').forEach(function (sel) {
        if (preserveResponse && sel.form && sel.form.querySelector('[data-reserve-response]')) return;
        var want = sel.dataset.reserveField === 'form' ? selectedLabel(formName) : selectedLabel(configName);
        selectReserveValue(sel, want);
      });
    }

    function updateVariant() {
      var opts = fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      var v = fieldsets.length ? variantFor(opts) : variants.find(function (x) { return String(x.id) === idInput.value; });
      if (!v) { if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = labels.sold; } return; }
      idInput.value = v.id;
      var priced = !v.on_request && typeof v.price === 'number';
      var total = priced ? selectedAddons().reduce(function (sum, a) { return sum + a.price; }, v.price) : 0;
      var summary = selectionText(v, total);
      setReserveSelection(summary);
      if (enquire) {
        var label = v.on_request ? enquire.dataset.enquireLabelComponent : enquire.dataset.enquireLabelBuild;
        if (label) enquire.textContent = label;
        var target = new URL(enquireHref, window.location.href);
        if (target.origin === window.location.origin && target.pathname !== window.location.pathname) {
          target.searchParams.set('variant', v.id);
          target.searchParams.set('form', selectedLabel(formName));
          target.searchParams.set('configuration', selectedLabel(configName));
          target.searchParams.set('selection', summary);
          enquire.href = target.toString();
        }
      }
      if (priceEl) { if (priced) priceEl.textContent = formatMoney(total); else priceEl.innerHTML = v.price_html; }
      if (depositEl) {
        depositEl.hidden = v.on_request;
        var amount = depositEl.querySelector('[data-deposit-amount]');
        if (amount) { if (priced) amount.textContent = formatMoney(Math.round(total * depositPercent / 100)); else amount.innerHTML = v.deposit_html; }
      }
      updateHints();
      if (buyBtn) { buyBtn.disabled = !v.available || v.on_request; buyBtn.textContent = v.available ? labels.add : labels.sold; }
      return v;
    }

    function update(push) {
      var v = updateVariant();
      updatePanels(!push);
      updateToggle();
      if (view === 'model' && currentModel()) setView('model');
      filterPhotos();
      if (push && v) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        url.searchParams.delete('form');
        url.searchParams.delete('configuration');
        url.searchParams.delete('config');
        window.history.replaceState({}, '', url.toString());
      }
    }

    // Preselect from links such as ?form=Arc&configuration=Cat-back
    var params = new URLSearchParams(window.location.search);
    var linkedVariant = variants.find(function (v) { return String(v.id) === params.get('variant'); });
    fieldsets.forEach(function (fs, index) {
      var want = linkedVariant ? linkedVariant.options[index] : params.get(fs.dataset.optionName) || (fs.dataset.optionName === configName ? params.get('configuration') || params.get('config') : fs.dataset.optionName === formName ? params.get('form') : null);
      if (!want) return;
      Array.prototype.forEach.call(fs.querySelectorAll('input'), function (i) { if (handle(i.value) === handle(want)) i.checked = true; });
    });
    if (params.get('view') === 'model') view = 'model';

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update(true);
      else if (e.target.closest('[data-addon-group]')) updateVariant();
    });

    // Linked add-on products go to the cart together with the system.
    form.addEventListener('submit', function (e) {
      if (!window.fetch || form.getAttribute('action') === '#') return;
      var extras = selectedAddons().filter(function (a) { return a.variant; });
      if (!extras.length) return;
      e.preventDefault();
      var properties = {};
      form.querySelectorAll('[data-addon-property]:not([disabled])').forEach(function (p) {
        properties[p.name.replace(/^properties\[|\]$/g, '')] = p.value;
      });
      var items = [{ id: Number(idInput.value), quantity: 1, properties: properties }].concat(extras.map(function (a) { return { id: Number(a.variant), quantity: 1 }; }));
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = base + 'cart'; })
        .catch(function () { form.submit(); });
    });
    update(false);
    if (view === 'model') setView('model');
  });

  // 3D viewers with tabs: the model loads only when the viewer comes into view.
  document.querySelectorAll('[data-viewer]').forEach(function (box) {
    var stage = box.querySelector('[data-viewer-stage]');
    var poster = box.querySelector('[data-viewer-poster]');
    var status = box.querySelector('[data-viewer-status]');
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
    var viewer = null;
    if (!tabs.length) return;
    function current() { return tabs.find(function (t) { return t.getAttribute('aria-selected') === 'true'; }) || tabs[0]; }
    function load(tab) {
      if (!tab.dataset.src) return;
      // Re-selecting the model already shown fires no new load event, so keep the poster hidden.
      var same = viewer && viewer.getAttribute('src') === tab.dataset.src;
      if (poster && tab.dataset.poster && !same) { poster.src = tab.dataset.poster; poster.hidden = false; }
      if (!viewer) {
        viewer = makeViewer(tab.dataset.src, tab.dataset.alt);
        viewer.addEventListener('load', function () { if (poster) poster.hidden = true; if (status) status.hidden = true; });
        viewer.addEventListener('error', function () {
          var t = current();
          t.disabled = true;
          if (poster) poster.hidden = false;
          var next = tabs.find(function (x) { return !x.disabled; });
          if (next && next !== t) select(next);
        });
        stage.appendChild(viewer);
      } else {
        viewer.setAttribute('src', tab.dataset.src);
        viewer.setAttribute('alt', tab.dataset.alt || '');
      }
      if (tab.dataset.orbit) { viewer.setAttribute('camera-orbit', tab.dataset.orbit); viewer.cameraOrbit = tab.dataset.orbit; }
      viewer.setAttribute('field-of-view', '24deg');
    }
    function select(tab) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      load(tab);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { select(t); }); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(current()); }
      }, { rootMargin: '300px 0px' });
      io.observe(box);
    } else {
      load(current());
    }
  });

  // Photo gallery: filters and a lightbox.
  document.querySelectorAll('[data-photo-gallery]').forEach(function (root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-group]'));
    var dialog = root.querySelector('[data-lightbox]');
    var img = root.querySelector('[data-lightbox-img]');
    var cap = root.querySelector('[data-lightbox-caption]');
    var index = 0;
    var photoLimit = Number(root.dataset.photoLimit) || items.length;
    var more = root.querySelector('[data-gallery-more]');
    var currentFilter = 'all';
    var expanded = false;
    function filterGallery() {
      var count = 0;
      items.forEach(function (item) {
        var matches = currentFilter === 'all' || item.dataset.group === currentFilter;
        if (matches) count++;
        item.hidden = !matches || (!expanded && count > photoLimit);
      });
      if (more) {
        more.hidden = count <= photoLimit;
        more.textContent = expanded ? 'Show fewer photos' : 'View all photos';
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }
    if (more) more.addEventListener('click', function () { expanded = !expanded; filterGallery(); });
    filterGallery();
    chips.forEach(function (c) {
      var n = c.dataset.filter === 'all' ? items.length : items.filter(function (i) { return i.dataset.group === c.dataset.filter; }).length;
      var count = c.querySelector('[data-count]');
      if (count) count.textContent = n;
      if (!n) c.hidden = true;
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        currentFilter = c.dataset.filter; expanded = false; filterGallery();
      });
    });
    function visible() { return items.filter(function (i) { return !i.hidden; }); }
    function show(k) {
      var list = visible();
      index = (k + list.length) % list.length;
      var b = list[index].querySelector('[data-full]');
      img.src = b.dataset.full;
      img.alt = b.dataset.caption || '';
      cap.textContent = (b.dataset.caption || '') + '  ·  ' + (index + 1) + ' / ' + list.length;
    }
    items.forEach(function (i) {
      var b = i.querySelector('[data-full]');
      b.addEventListener('click', function () {
        show(visible().indexOf(i));
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      });
    });
    root.querySelector('[data-lightbox-prev]').addEventListener('click', function () { show(index - 1); });
    root.querySelector('[data-lightbox-next]').addEventListener('click', function () { show(index + 1); });
    root.querySelector('[data-lightbox-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
  });

  // Film chapters seek the video.
  document.querySelectorAll('[data-film]').forEach(function (root) {
    var video = root.querySelector('video');
    // The film starts only when it scrolls into view, so its file does not load with the page.
    if (video && !video.autoplay && 'IntersectionObserver' in window) {
      video.muted = true;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          else video.pause();
        });
      }, { threshold: 0.35 }).observe(video);
    }
    root.querySelectorAll('[data-seek]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!video) return;
        video.currentTime = parseFloat(b.dataset.seek) || 0;
        video.play();
      });
    });
  });
})();
